import React from "react";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import AppRoutes from "./Routes";

const App = () => {
  return (
    <div className="App" id="page">
      <Header />
      <main>
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
};

export default App;
